import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_impl_basic_medical_surveillance_techniques_monitor_wkrs'

export const dataPointDefinition = {
  retracedId: 'no_impl_basic_medical_surveillance_techniques_monitor_wkrs',
  name: 'No implementation of basic medical surveillance techniques to monitor workers who are exposed to heat/cold sources',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-wor-63x',
      number: 'HS-WOR-29-4',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-wor-59',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-wor-17,Yes',
      machineShowHide: '[2],hs-wor-17,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-wor-63x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 32030,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
